"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
class RuleApplicationOutcome {
    constructor(validationFailure) {
        this.validationFailure = validationFailure;
        this.failures = [];
        if (validationFailure) {
            this.addValidationFailure(validationFailure);
        }
    }
    isSuccess() {
        return this.failures.length === 0;
    }
    isFailure() {
        return !this.isSuccess();
    }
    addValidationFailure(failure) {
        this.failures.push(failure);
    }
    getValidationFailures() {
        return this.failures.slice(0);
    }
}
exports.RuleApplicationOutcome = RuleApplicationOutcome;
//# sourceMappingURL=RuleApplicationOutcome.js.map